/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type UserWidget_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type DowntimeOverlay_downtime$ref: FragmentReference;
declare export opaque type DowntimeOverlay_downtime$fragmentType: DowntimeOverlay_downtime$ref;
export type DowntimeOverlay_downtime = {|
  +id: string,
  +startNotes: ?string,
  +startAt: ?any,
  +category: {|
    +id: string,
    +name: string,
  |},
  +startUser: ?{|
    +$fragmentRefs: UserWidget_user$ref
  |},
  +$refType: DowntimeOverlay_downtime$ref,
|};
export type DowntimeOverlay_downtime$data = DowntimeOverlay_downtime;
export type DowntimeOverlay_downtime$key = {
  +$data?: DowntimeOverlay_downtime$data,
  +$fragmentRefs: DowntimeOverlay_downtime$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "DowntimeOverlay_downtime",
  "type": "MachineDowntime",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "startNotes",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "startAt",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "category",
      "storageKey": null,
      "args": null,
      "concreteType": "DowntimeCategory",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "startUser",
      "storageKey": null,
      "args": null,
      "concreteType": "User",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "UserWidget_user",
          "args": null
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '80c64eef9de3cf9f031f3e25a2f44c46';
module.exports = node;
